import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import { ViewVariant } from "@/common/ts/layout";
import { AssetSubscriptionDto } from "@/core/api/generated/v1";

import CustomerView from "../../../Customer/View/CustomerView";

interface Props {
  assetSubscription: AssetSubscriptionDto;
}

export default function CustomerTabContent({ assetSubscription }: Props) {
  return (
    <PageTabContent>
      <Stack direction='column' spacing={2}>
        <CustomerView
          customerId={assetSubscription.customer?.id}
          customer={undefined}
          displayProps={{
            breadcrumbs: false,
            header: false,
            actions: false,
            viewVariant: ViewVariant.Tab,
          }}
          headerProps={{
            withLink: true,
            typographyProps: pageTabHeaderTypographyProps.title,
          }}
          onDelete={null}
        />
      </Stack>
    </PageTabContent>
  );
}
